
	import ModeloCadastro from '@/views/paginas/sigap/modelos/ModeloCadastro.vue';   
    import { Options   } from "vue-class-component";   
    import {  HoraAula } from "./HoraAula";
	import $ from "jquery" 
    import { PerfilConfig } from "@/core/config/PerfisConfig";
    import   SiteUtils   from '@/assets/ts/aplicacao/site'; 
	  
    @Options({
        name: "HoraAulaCadastro",
        components: {   },  
        emits: [  'hora-aula-cadastrado'],  
    }) 
    export default class HoraAulaCadastro extends ModeloCadastro {
        
        created() {  
            this.campos =  HoraAula.campos();  
        }
   
        get hasPermissao(   ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin,  PerfilConfig.ChefeSTE ] ,  this.perfis); 
        }
   
        public sucesso(){  
            this.$emit("hora-aula-cadastrado", null);     
            $("[data-bs-dismiss='modal']").trigger({ type: "click" });
        }

        public  salvar(){
            if( this.processando  ||  !this.hasPermissao ){
                return;
            }
            this.processando = true ;  
            let dados = this.getdados() ;  
            setTimeout(() => {  
                this.service.cadastrar(   dados )
                .then(response => { 
                    SiteUtils.toastSucesso('Cadastrado com sucesso! ' ,  response.message  );
                    this.formulario = {};
                    this.sucesso();  
                    this.processando = false ; 
                    this.editando = false ;
                }) 
                .catch(error => {
                    this.processando = false ;
                    if(error.status == 422 ){
                        SiteUtils.toastErro('Error!' ,   error.data.message  );
                        if( typeof error.data.duplicidade !== "undefined" ){
                            SiteUtils.toastErro('Item Existente! ' ,  JSON.stringify(error.data.duplicidade ) );
                        } 
                    }
                    else{
                        SiteUtils.toastErro('Error! ' ,  error.data.message  );
                    } 
                });  
            }, 100); 
        }  

    } 
